// extracted by mini-css-extract-plugin
export default {"info":"CalendarInfo_info__HLMn5"};